<template>
  <div>
    <section>
      <div class="category-title-bg py-3">
        <!-- <router-link :to="`videos?c=${category.code}`"> -->
        <span>Select your Country</span>
        <!-- </router-link> -->
      </div>
      <!-- <div><CategorySlider :codes="category.code" /></div> -->
    </section>
    <section class="bg-black hhv-100">
      <div class="container py-5">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-4">
            <div class="mb-4 mt-5">
              <!-- <h4 class="text-warning">Question 1: How to watch the video?</h4>
              <p class="text-white">
                Answer 1: <br />
                You need to register first then subscribe to the service.
              </p> -->
              <p class="text-center text-white">Countries</p>
              <div>
                <div
                  v-for="(country, i) in countries"
                  :key="i"
                  class="country"
                  @click.prevent="selectCountry(country)"
                >
                  {{ country.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      class="position-fixed bottom-0 right-0 p-3"
      style="z-index: 9999; right: 0; bottom: 0"
    >
      <div
        id="liveToast"
        class="toast hide"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-delay="2000"
      >
        <div class="toast-header">
          <strong class="mr-auto">Message</strong>
          <!-- <small>11 mins ago</small> -->
          <button
            type="button"
            class="ml-2 mb-1 close"
            data-dismiss="toast"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="toast-body">
          You need to login or create an account first.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Featured from "./Featured.vue";
// import SkeletonThumbnail from "../components/SkeletonThumbnail.vue";
// import $ from "jquery";
// import moment from "moment";
export default {
  components: {
    // Featured,
    // SkeletonThumbnail,
  },

  data() {
    return {
      countries: [],
      category: {},
      countryCode: "",
    };
  },

  methods: {
    async getContent() {
      await this.$api
        .get("/Country")
        .then((response) => {
          const res = response.data;
          // this.contents = res;
          this.countries = res;
          console.log(res);
        })
        .catch((e) => {
          console.log(e);
          // this.loadingBtn = false;
        });
    },

    selectCountry(item) {
      // if (item.code === "PH") {
      //   localStorage.setItem("country_code", item.code);
      //   window.location = item.domain;
      //   return;
      // }

      // if (item.code === "PL") {
      localStorage.setItem("country_code", item.code);
      window.location = item.domain;
      // return;
      // }
    },
  },

  created() {
    this.getContent();
    // this.getCountry();

    // const cc = localStorage.getItem("country_code");

    // if (cc) {
    //   // console.log("app ...");
    //   this.$router.push({ path: "/" });
    //   return;
    // }
  },

  computed: {},
};
</script>

<style scoped>
.video-time {
  position: absolute;
  background-color: #fff;
  right: 5px;
  padding: 0px 10px;
  border-radius: 5px;
  bottom: 10px;
  font-size: 0.8rem;
}
.video-img {
  border-radius: 10px;
  height: 100%;
}

.hhv-100 {
  height: 100vh;
}

@media only screen and (max-width: 767px) {
  .videos-thumbs-container {
    height: 200px;
  }

  .hhv-100 {
    height: 100%;
  }

  .video-img {
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
    object-fit: cover;
  }
}

.country {
  border: 1px solid #fff;
  padding: 10px 15px;
  color: #fff;
  margin-bottom: 15px;
}

.country:hover {
  background-color: #fff;
  color: #000;
  cursor: pointer;
}
</style>
